import { Injectable, Optional } from '@angular/core';
import { Entity, EntityManager } from 'breeze-client';
import { Observable, Subject } from 'rxjs';
import { SaveHandlers, UnitOfWorkBase } from '.';
import { BusyService } from './busy.service';
import { EntityTypeLike } from './entity-selector';
import { EntityPropertyPaths, GenericRepository, Repository } from './repository';

export interface UnitOfWorkClearEvent {
  unitOfWork: UnitOfWorkBase;
  manager: EntityManager;
}

@Injectable({
  providedIn: 'root',
})
export class UnitOfWorkHelper {
  private _cleared$ = new Subject<UnitOfWorkClearEvent>();

  get cleared$(): Observable<UnitOfWorkClearEvent> {
    return this._cleared$.asObservable();
  }

  constructor(readonly busyService: BusyService, @Optional() readonly saveHandlers: SaveHandlers) {}

  createRepository<T extends Entity>(
    manager: EntityManager,
    entityTypeLike: EntityTypeLike<T>,
    expand: EntityPropertyPaths<T>,
    resourceName: string,
    isCached: boolean = false
  ): Repository<T> {
    return new GenericRepository<T>(this, manager, entityTypeLike, expand, resourceName, isCached);
  }

  signalClear(unitOfWork: UnitOfWorkBase, manager: EntityManager): void {
    this._cleared$.next({
      unitOfWork,
      manager,
    });
  }
}
